export default __webpack_public_path__ + "static/media/nextchapterpanel.42ffaa67.png";